import { ReactNode } from 'react';
import { styled, Typography } from '@mui/material';
import Spacer from '@components/layout-util-components/spacer';
import { Gap } from '@components/layout-util-components/gap';

interface Props {
  icon: ReactNode;
  title: string;
  message?: string;
  action?: ReactNode;
  asRow?: boolean;
}

const Container = styled('div')<{ asRow?: boolean }>(({ asRow }) => ({
  display: 'flex',
  flexDirection: asRow ? 'row' : 'column',
  gap: asRow ? 18 : 40,
  justifyContent: 'center',
  alignItems: 'center',

  h4: {
    margin: 0,
    padding: 0,
  },
}));

export default function EmptySection({
  icon,
  title,
  message,
  action,
  asRow,
}: Props) {
  return (
    <Container asRow={asRow}>
      {icon ? icon : null}
      <div>
        <h4>{title}</h4>
        {message ? (
          <>
            <Gap size={12} />
            <Typography variant="body1">{message}</Typography>
          </>
        ) : null}
      </div>
      {action ? (
        <>
          <Spacer />
          {action}
        </>
      ) : null}
    </Container>
  );
}
